import { connect } from 'react-redux';

import MinervaInfo from './component';
import { compose, lifecycle } from 'recompose';
import { fetchMinervaInfo } from 'redux/modules/job-detail/effects';
import { getMinervaInfo } from 'redux/modules/job-detail/selectors';

const actionCreators = {
  fetchMinervaInfo,
};

const enhance = compose(
  connect((state) => {
    return {
      minervaInfo: getMinervaInfo(state),
    };
  }, actionCreators),
  lifecycle({
    componentDidMount() {
      const { fetchMinervaInfo } = this.props;
      fetchMinervaInfo();
    },
  })
);

export default enhance(MinervaInfo);
